// ============================================================================
// post-client-mod -- 文章状态徽标
// ============================================================================
import * as React from 'react';
/** 状态配置：显示文本 + 颜色 */
const STATUS_CONFIG = {
    draft: {
        label: '草稿',
        bg: '#fef3c7',
        text: '#92400e',
    },
    published: {
        label: '已发布',
        bg: '#d1fae5',
        text: '#065f46',
    },
    archived: {
        label: '已归档',
        bg: '#e5e7eb',
        text: '#374151',
    },
};
/**
 * 文章状态徽标
 */
export function PostStatusBadge({ status }) {
    const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;
    return React.createElement('span', {
        style: {
            display: 'inline-block',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 600,
            backgroundColor: config.bg,
            color: config.text,
            lineHeight: '16px',
        },
    }, config.label);
}
/** 获取状态标签文本 */
export function getStatusLabel(status) {
    return STATUS_CONFIG[status]?.label ?? status;
}
//# sourceMappingURL=post-status-badge.js.map